import { Params } from './types';

export const validate = (params: Params) => {
  if (!params.basket_ids?.[0]) return ['Benchmark is a required field.'];
  return [];
};
